<app-media-page
  [loading]="loading"
  [medias]="medias$ | async"
  [hasNextPage]="hasNextPage"
  title="Mon historique"
  color="light-green"
></app-media-page>
